<section
  class="tw-flex tw-flex-col tw-m-auto tw-p-4 tw-pb-6 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-shadow-sm tw-rounded-xl tw-bg-white dark:tw-bg-gray-800"
  id="webhooks"
>
  <div class="tw-mb-5 tw-flex tw-flex-col tw-gap-1 tw-items-start">
    <div class="tw-flex tw-w-full tw-flex-col tw-gap-4 lg:tw-flex-row lg:tw-items-start lg:tw-justify-between">
      <div class="tw-flex tw-flex-col tw-gap-1">
        <h2 class="tw-font-bold tw-text-gray-700 dark:tw-text-gray-100 tw-text-lg tw-font-inter">
          {{ 'v2.orgSettings.webhooks.webhooks' | translate }}
        </h2>
        <p class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-300 tw-text-start tw-font-inter tw-font-normal">
          {{ 'v2.orgSettings.webhooks.description' | translate }}
          <a href="http://developer.micetribe.com/" target="_blank" class="tw-text-blue-600 tw-font-bold tw-cursor-pointer">{{
            'v2.orgSettings.webhooks.learnMore' | translate
          }}</a>
        </p>
      </div>

      @if (!showInitialEmptyState()) {
      <button
        type="button"
        class="tw-inline-flex tw-shrink-0 tw-items-center tw-gap-2 tw-self-start tw-rounded-md tw-bg-blue-600 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-blue-700"
        (click)="openCreateWebhookModal()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <g clip-path="url(#clip0_47657_39042)">
            <path
              d="M6.00146 0.499023V5.99902M6.00146 5.99902V11.499M6.00146 5.99902H11.5015M6.00146 5.99902H0.501465"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_47657_39042">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
        {{ 'v2.orgSettings.webhooks.create' | translate }}
      </button>
      }
    </div>
  </div>

  @if (showInitialEmptyState()) {
  <div class="tw-flex tw-flex-col tw-gap-6 tw-items-center">
    <div class="tw-w-[230px] tw-h-[230px] md:tw-w-[254px] md:tw-h-[254px]" [innerHTML]="emptyStateIcon | safe"></div>
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
      <p class="tw-text-center tw-justify-center tw-text-gray-900 tw-text-base md:tw-text-xl tw-font-bold tw-font-['Inter'] tw-leading-8 tw-mb-2">
        {{ 'v2.orgSettings.webhooks.noWebhookYet' | translate }}
      </p>
      <p
        class="tw-max-w-[650px] tw-self-stretch tw-text-center tw-justify-center tw-text-gray-500 tw-text-xs md:tw-text-base tw-font-medium tw-font-['Inter'] tw-leading-4 md:tw-leading-6 tw-mb-6"
      >
        {{ 'v2.orgSettings.webhooks.noWebhookYetDescription' | translate }}
      </p>
      <button
        type="button"
        class="tw-px-5 tw-py-2.5 md:tw-py-3 tw-bg-blue-600 tw-rounded-lg tw-inline-flex tw-justify-center tw-items-center tw-gap-2"
        (click)="openCreateWebhookModal()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-[14px] tw-w-[14px] md:tw-h-4 md:tw-w-4" viewBox="0 0 14 14" fill="none">
          <g clip-path="url(#clip0_47465_30056)">
            <path
              d="M7.00163 0.582031V6.9987M7.00163 6.9987V13.4154M7.00163 6.9987H13.4183M7.00163 6.9987H0.584961"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_47465_30056">
              <rect width="14" height="14" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <div class="tw-justify-start tw-text-white tw-text-sm md:text-base tw-font-medium tw-font-['Inter'] tw-leading-5 md:tw-leading-6">
          {{ 'v2.orgSettings.webhooks.createFirstWebhook' | translate }}
        </div>
      </button>
    </div>
  </div>
  } @else {
  <div class="tw-flex tw-flex-col tw-gap-4">
    <div class="tw-flex tw-gap-3 lg:tw-w-fit lg:tw-gap-0">
      <div class="tw-relative tw-min-w-0 tw-flex-1 lg:tw-w-[325px] lg:tw-flex-none">
        <span class="tw-pointer-events-none tw-absolute tw-start-3 tw-top-1/2 tw-z-10 -tw-translate-y-1/2 tw-text-gray-500">
          <svg class="tw-h-4 tw-w-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
              stroke="currentColor"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M14 14L11.1 11.1" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <input
          type="search"
          [formControl]="searchControl"
          [placeholder]="'v2.orgSettings.webhooks.searchPlaceholder' | translate"
          class="tw-h-11 tw-w-full tw-rounded-lg tw-border tw-border-gray-300 tw-bg-gray-50 tw-ps-10 tw-pe-3 tw-text-sm tw-text-gray-900 tw-outline-none focus:tw-border-blue-600 focus:tw-ring-0 dark:tw-border-gray-600 dark:tw-bg-gray-700 dark:tw-text-white placeholder:tw-text-gray-500"
        />
      </div>

      <app-filter-button [activeCount]="mobileActiveFilterCount()" (clicked)="onMobileFilterOpen()" />

      <div class="webhook-event-filter tw-hidden tw-w-[220px] tw-shrink-0 lg:tw-block tw-ms-3">
        <select-input
          class="tw-w-full"
          [control]="eventFilterControl"
          [placeholder]="'v2.orgSettings.webhooks.allEvents' | translate"
          key="name"
          valueName="id"
          [values]="events()"
          [isDropdown]="true"
          [basicSelect]="true"
          [isBasicDropdownValue]="true"
          [enableSearch]="true"
          [isSingleSelect]="true"
          [clearAll]="true"
          [showTooltip]="true"
          label=""
          id="webhook-event-filter"
        ></select-input>
      </div>
    </div>

    <div
      #webhooksList
      class="webhooks-list-scroll tw-flex tw-flex-col tw-gap-3 tw-min-h-0 tw-overflow-y-auto"
      infiniteScroll
      [scrollWindow]="false"
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="150"
      [immediateCheck]="true"
      [infiniteScrollDisabled]="infiniteScrollDisabled()"
      (scrolled)="onWebhooksListScroll()"
    >
      @if (isLoadingWebhooks()) {
      <div class="tw-flex tw-flex-col tw-gap-3" role="status" [attr.aria-label]="'v2.orgSettings.webhooks.webhooks' | translate">
        @for (_skeleton of [1, 2, 3]; track $index) {
        <div class="tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-200 tw-bg-gray-50 tw-p-4 dark:tw-border-gray-600 dark:tw-bg-gray-800">
          <div class="tw-flex tw-items-center tw-gap-3">
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '40px',
                height: '20px',
                'border-radius': '9999px',
                backgroundColor: getSkeletonTheme().backgroundColor,
                color: getSkeletonTheme().color,
                marginBottom: '0'
              }"
              animation="pulse"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              class="tw-flex-1"
              [theme]="{
                width: '100%',
                height: '16px',
                'border-radius': '4px',
                backgroundColor: getSkeletonTheme().backgroundColor,
                color: getSkeletonTheme().color,
                marginBottom: '0'
              }"
              animation="pulse"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '96px',
                height: '32px',
                'border-radius': '6px',
                backgroundColor: getSkeletonTheme().backgroundColor,
                color: getSkeletonTheme().color,
                marginBottom: '0'
              }"
              animation="pulse"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                width: '32px',
                height: '32px',
                'border-radius': '6px',
                backgroundColor: getSkeletonTheme().backgroundColor,
                color: getSkeletonTheme().color,
                marginBottom: '0'
              }"
              animation="pulse"
            ></ngx-skeleton-loader>
          </div>
        </div>
        }
      </div>
      } @else { @for (webhook of webHooks(); track webhook.id) {
      <webhook-card
        [webhook]="webhook"
        (webhookUpdated)="onWebhookUpdated($event)"
        (editRequested)="onEditRequested($event)"
        (deleteRequested)="onDeleteRequested($event)"
        (logsRequested)="onLogsRequested($event)"
      ></webhook-card>
      } @empty {
      <p class="tw-py-8 tw-text-center tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">
        {{ 'v2.orgSettings.webhooks.noMatchingWebhooks' | translate }}
      </p>
      } @if (isLoadingMore()) {
      <ngx-skeleton-loader
        count="1"
        [theme]="{ width: '100%', height: '56px', 'border-radius': '8px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color, marginBottom: '0' }"
        animation="pulse"
      ></ngx-skeleton-loader>
      } }
    </div>
  </div>
  }
</section>

<app-mobile-filter-drawer
  [title]="'v2.orgSettings.webhooks.filterBy' | translate"
  (reset)="onMobileFilterReset()"
  (apply)="onMobileFilterApply()"
  (closed)="onMobileFilterClosed()"
>
  <app-mobile-accordion [title]="'v2.orgSettings.webhooks.event' | translate" [isLast]="true">
    <app-filter-option
      [label]="'v2.orgSettings.webhooks.allEvents' | translate"
      [selected]="mobileEventFilterDraft() === null"
      (selectedChange)="setMobileEventFilterDraft(null)"
    />

    @for (event of events(); track event.id) {
    <app-filter-option [label]="event.name" [selected]="mobileEventFilterDraft() === event.id" (selectedChange)="setMobileEventFilterDraft(event.id)" />
    }
  </app-mobile-accordion>
</app-mobile-filter-drawer>

@if (isModalOpened(createModalId)) {
<create-webhook-modal
  [id]="createModalId"
  [events]="events()"
  [isLoadingEvents]="isLoadingEvents()"
  (webhookCreated)="onWebhookCreated()"
  (cancelled)="closeCreateWebhookModal()"
></create-webhook-modal>
} @if (isModalOpened(editModalId) && editingWebhook(); as webhook) {
<create-webhook-modal
  [id]="editModalId"
  [webhook]="webhook"
  [events]="events()"
  [isLoadingEvents]="isLoadingEvents()"
  (webhookUpdated)="onWebhookEdited($event)"
  (cancelled)="closeEditWebhookModal()"
></create-webhook-modal>
} @if (isModalOpened(deleteWebhookModalId)) {
<delete-modal
  [id]="deleteWebhookModalId"
  [message]="deleteWebhookConfirmMessage()"
  [confirmBtnLabel]="'v2.orgSettings.webhooks.deleteWebhookConfirmYes' | translate"
  [cancelBtnLabel]="'v2.orgSettings.webhooks.deleteWebhookConfirmNo' | translate"
  (onDelete)="confirmWebhookDeletion()"
  (onCancel)="cancelWebhookDeletion()"
></delete-modal>
}
